export const MSGraphServiceErrorCodes = {
  ResourceNotFound: 'Request_ResourceNotFound',
};
